export * from './baMenu.service';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/services/baMenu/index.ts